<template>
  <v-app :class="{'app-dark': $vuetify.theme.dark, 'app-light': !$vuetify.theme.dark}">
    <div v-if="loading" ></div>
    <!-- class="loading-overlay" -->
    <div v-else ></div>
    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
      stateless
      width="220"
      v-if="mySelf"
      class="glass"
      :class="{'nav-drawer-dark': $vuetify.theme.dark, 'nav-drawer-light': !$vuetify.theme.dark}"
    >
      <!-- Logo/Brand Header -->
      <div class="nav-brand pa-4">
        <div class="d-flex align-center">
          <v-icon large :color="$vuetify.theme.dark ? 'energyCyan' : 'primary'" class="mr-2">mdi-flash</v-icon>
          <span class="nav-brand-text">SMART ENERGY</span>
        </div>
      </div>
      
      <v-divider :class="$vuetify.theme.dark ? 'divider-dark' : 'divider-light'"></v-divider>

      <v-list class="pt-2 nav-list">
        <template v-if="homeNavigationItem">
          <v-list-item
            :key="homeNavigationItem.title"
            v-on:click="
              drawer = false;
              pushRoute(homeNavigationItem);
            "
            class="nav-item nav-home-item my-1 mx-2"
            :class="{'nav-item-active': $route.path === homeNavigationItem.path}"
          >
            <v-list-item-action>
              <v-icon medium :color="$vuetify.theme.dark ? 'energyCyan' : homeNavigationItem.color">
                {{ homeNavigationItem.icon }}
              </v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title class="text-capitalize nav-item-text">
                {{ $t(homeNavigationItem.title) }}
              </v-list-item-title>
              <v-list-item-subtitle
                v-if="homeNavigationItem.descriptionKey"
                class="nav-item-subtitle"
              >
                {{ $t(homeNavigationItem.descriptionKey) }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider
            class="nav-section-divider my-3 mx-4"
            :class="$vuetify.theme.dark ? 'divider-dark' : 'divider-light'"
          ></v-divider>
        </template>

        <v-list-item
          v-for="item in sortedNavigationItems"
          :key="item.title"
          v-on:click="
            drawer = false;
            pushRoute(item);
          "
          class="nav-item my-1 mx-2"
          :class="{'nav-item-active': $route.path === item.path}"
        >
          <v-list-item-action>
            <v-icon medium :color="$vuetify.theme.dark ? 'energyCyan' : item.color">{{ item.icon }}</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title class="text-capitalize nav-item-text">{{
              $t(item.title)
            }}</v-list-item-title>
            <v-list-item-subtitle v-if="item.descriptionKey" class="nav-item-subtitle">
              {{ $t(item.descriptionKey) }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="my-3 mx-4" :class="$vuetify.theme.dark ? 'divider-dark' : 'divider-light'"></v-divider>

        <v-list-item class="nav-item mx-2" v-if="mySelf" v-on:click="logout()">
          <v-list-item-action>
            <v-icon medium :color="$vuetify.theme.dark ? 'error' : 'error'">mdi-logout</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title class="text-capitalize nav-item-text">{{
              $t("Logout")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <!-- Footer Info -->
      <template v-slot:append>
        <div class="nav-footer pa-3">
          <div class="caption nav-footer-text">{{ sw_name }}</div>
          <div class="caption nav-footer-text">{{ sw_version }} · {{ developer }}</div>
          <div class="caption nav-footer-text mt-1">{{ web }}</div>
        </div>
      </template>
    </v-navigation-drawer>

    <!-- App Bar für eingeloggte User -->
    <v-app-bar
      v-if="mySelf"
      dense
      clipped-left
      fixed
      app
      flat
      :extension-height="showProjectSelector && isMobile ? 52 : 0"
      :class="{'app-bar-dark': $vuetify.theme.dark, 'app-bar-light': !$vuetify.theme.dark}"
      class="glass"
    >
      <v-btn icon @click="drawer = !drawer">
        <v-icon :color="$vuetify.theme.dark ? 'energyCyan' : 'primary'">mdi-menu</v-icon>
      </v-btn>
      
      <v-icon class="ml-2" :color="$vuetify.theme.dark ? 'energyAmber' : 'primary'">mdi-flash</v-icon>
      <span class="app-bar-title ml-2 hidden-xs-only">{{ $t($route.name) }}</span>

      <v-chip v-if="isSupportSession" color="warning" class="ml-4" small>
        <v-icon small left>mdi-account-eye</v-icon>
        Support als {{ mySelf.displayname || mySelf.email }}
        <v-btn icon x-small class="ml-1" @click="endSupportSession">
          <v-icon x-small>mdi-close</v-icon>
        </v-btn>
      </v-chip>

      <v-select
        v-if="showProjectSelector && !isMobile"
        v-model="selectedProjectId"
        :items="projectSelectItems"
        item-text="projectSelectText"
        item-value="_id"
        :menu-props="{ maxHeight: 600 }"
        label="Projekt"
        dense
        outlined
        hide-details
        class="global-project-select ml-4"
      >
        <template v-slot:selection="{ item }">
          <span class="text-truncate">{{ item.name || "Unbenannt" }}</span>
          <v-chip
            x-small
            class="project-priority-chip ml-2"
            :color="item.priorityOneAlertCount > 0 ? 'error' : 'grey'"
            :dark="item.priorityOneAlertCount > 0"
            :outlined="item.priorityOneAlertCount === 0"
          >
            <v-icon v-if="item.priorityOneAlertCount > 0" x-small left>mdi-alert</v-icon>
            {{ item.priorityOneAlertCount }}
          </v-chip>
        </template>
        <template v-slot:item="{ item }">
          <span>{{ item.name || "Unbenannt" }}</span>
          <v-chip
            x-small
            class="project-priority-chip ml-2"
            :color="item.priorityOneAlertCount > 0 ? 'error' : 'grey'"
            :dark="item.priorityOneAlertCount > 0"
            :outlined="item.priorityOneAlertCount === 0"
          >
            <v-icon v-if="item.priorityOneAlertCount > 0" x-small left>mdi-alert</v-icon>
            {{ item.priorityOneAlertCount }}
          </v-chip>
        </template>
      </v-select>

      <template v-if="showProjectSelector && isMobile" v-slot:extension>
        <v-select
          v-model="selectedProjectId"
          :items="projectSelectItems"
          item-text="projectSelectText"
          item-value="_id"
          :menu-props="{ maxHeight: 600, offsetY: true }"
          label="Projekt"
          dense
          outlined
          hide-details
          class="global-project-select global-project-select-mobile"
        >
          <template v-slot:selection="{ item }">
            <v-icon small class="mr-2">mdi-folder-outline</v-icon>
            <span class="text-truncate">{{ item.name || "Unbenannt" }}</span>
            <v-chip
              x-small
              class="project-priority-chip ml-2"
              :color="item.priorityOneAlertCount > 0 ? 'error' : 'grey'"
              :dark="item.priorityOneAlertCount > 0"
              :outlined="item.priorityOneAlertCount === 0"
            >
              <v-icon v-if="item.priorityOneAlertCount > 0" x-small left>mdi-alert</v-icon>
              {{ item.priorityOneAlertCount }}
            </v-chip>
          </template>
          <template v-slot:item="{ item }">
            <span class="text-truncate">{{ item.name || "Unbenannt" }}</span>
            <v-chip
              x-small
              class="project-priority-chip ml-2"
              :color="item.priorityOneAlertCount > 0 ? 'error' : 'grey'"
              :dark="item.priorityOneAlertCount > 0"
              :outlined="item.priorityOneAlertCount === 0"
            >
              <v-icon v-if="item.priorityOneAlertCount > 0" x-small left>mdi-alert</v-icon>
              {{ item.priorityOneAlertCount }}
            </v-chip>
          </template>
        </v-select>
      </template>

      <v-chip
        v-if="isAdmin && projectAlertCount > 0"
        small
        color="warning"
        class="ml-2"
        @click="openProjectAlerts"
      >
        <v-icon small left>mdi-alert-circle</v-icon>
        {{ projectAlertCount }}<span class="hidden-xs-only ml-1">Alerts</span>
      </v-chip>

      <v-chip
        v-if="isAdmin && pendingMqttPermissionCount > 0"
        small
        color="deep-orange darken-2"
        text-color="white"
        class="ml-2"
        @click="openMqttPermissions"
      >
        <v-icon small left>mdi-shield-alert-outline</v-icon>
        {{ pendingMqttPermissionCount }}<span class="hidden-xs-only ml-1">MQTT</span>
      </v-chip>

      <v-tooltip v-if="isAdmin" bottom>
        <template v-slot:activator="{ on }">
          <v-chip
            class="ml-3 agent-api-status"
            :color="agentApiStatusColor"
            :outlined="$vuetify.theme.dark"
            small
            v-on="on"
            @click="checkAgentApiStatus"
          >
            <v-icon small left>{{ agentApiStatusIcon }}</v-icon>
            <span class="hidden-sm-and-down">{{ agentApiStatusLabel }}</span>
          </v-chip>
        </template>
        <span>{{ agentApiStatusTooltip }}</span>
      </v-tooltip>

      <v-spacer></v-spacer>
      
      <!-- Layout Mode Toggle -->
      <v-btn-toggle 
        dense 
        class="mode-toggle mr-2" 
        v-model="layoutMode" 
        mandatory 
        v-if="$route.name == 'home'"
        :class="{'mode-toggle-dark': $vuetify.theme.dark}"
      >
        <v-btn dense :value="1" small>1</v-btn>
        <v-btn dense :value="2" small>2</v-btn>
        <v-btn dense :value="4" small v-if="!isMobile">4</v-btn>
      </v-btn-toggle>

      <v-spacer></v-spacer>

      <template v-if="isAdmin && !isMobile">
        <v-autocomplete
          v-model="selectedSupportUserId"
          :items="supportUserItems"
          item-text="label"
          item-value="_id"
          label="Benutzer-Support"
          dense
          outlined
          hide-details
          clearable
          class="support-user-select mr-1"
        ></v-autocomplete>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon :disabled="!selectedSupportUserId || supportLaunchPending" v-on="on" @click="openSupportApplication('dashboard')">
              <v-icon>mdi-monitor-account</v-icon>
            </v-btn>
          </template>
          <span>Dashboard als Benutzer öffnen</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon :disabled="!selectedSupportUserId || !selectedSupportUserIsObs || supportLaunchPending" v-on="on" @click="openSupportApplication('obs_web')">
              <v-icon>mdi-open-in-new</v-icon>
            </v-btn>
          </template>
          <span>OBS als Benutzer öffnen</span>
        </v-tooltip>
      </template>

      <v-tooltip v-if="!isSupportSession" bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon class="mr-1" aria-label="Nachrichten öffnen" v-on="on" @click="openMessages">
            <v-badge :content="unreadMessageCount" :value="unreadMessageCount" color="error" overlap>
              <v-icon :color="$route.name === 'Nachrichten' ? 'primary' : undefined">mdi-message-text-outline</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span>Nachrichten</span>
      </v-tooltip>

      <v-tooltip v-if="pwaInstallAvailable && isMobile && !isSupportSession" bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon aria-label="App installieren" v-on="on" @click="openPwaInstall">
            <v-icon>mdi-cellphone-arrow-down</v-icon>
          </v-btn>
        </template>
        <span>App installieren</span>
      </v-tooltip>
      
      <!-- Light/Dark Mode Toggle -->
      <v-btn icon small @click="toggleDarkMode" class="mr-2">
        <v-icon :color="$vuetify.theme.dark ? 'energyAmber' : 'grey darken-1'">
          {{ $vuetify.theme.dark ? 'mdi-white-balance-sunny' : 'mdi-moon-waning-crescent' }}
        </v-icon>
      </v-btn>
      
      <!-- Fixed loading/reload slot: keeps the adjacent actions stationary. -->
      <div class="app-bar-reload-slot" aria-live="polite">
        <v-progress-circular
          v-if="loading"
          :color="$vuetify.theme.dark ? 'energyCyan' : 'primary'"
          :indeterminate="true"
          :size="24"
          :width="3"
          aria-label="Dashboard wird aktualisiert"
        ></v-progress-circular>
      </div>
    </v-app-bar>

    <!-- App Bar für nicht eingeloggte User (Login/SignUp) -->
    <v-app-bar
      v-else
      dense
      clipped-left
      fixed
      app
      flat
      :class="{'app-bar-dark': $vuetify.theme.dark, 'app-bar-light': !$vuetify.theme.dark}"
    >
      <v-icon :color="$vuetify.theme.dark ? 'energyCyan' : 'primary'" class="mr-2">mdi-flash</v-icon>
      <span class="app-bar-title">Schwarzl IT - Smart Energy Management System</span>
      <v-spacer></v-spacer>
      
      <!-- Light/Dark Mode Toggle on Login -->
      <v-btn icon small @click="toggleDarkMode" class="mr-2">
        <v-icon :color="$vuetify.theme.dark ? 'energyAmber' : 'grey darken-1'">
          {{ $vuetify.theme.dark ? 'mdi-white-balance-sunny' : 'mdi-moon-waning-crescent' }}
        </v-icon>
      </v-btn>
    </v-app-bar>

    <!-- Main Content -->
    <v-main>
      <v-progress-linear
        v-if="!mySelf"
        :color="$vuetify.theme.dark ? 'energyCyan' : 'primary'"
        :active="loading"
        :height="3"
        class="ma-0"
        indeterminate
      ></v-progress-linear>
      <div class="main-content-area">
        <router-view class="pt-0" :layoutMode="layoutMode"></router-view>
      </div>
    </v-main>

    <v-snackbar v-model="supportLaunchErrorVisible" color="error" :timeout="6000">
      {{ supportLaunchError }}
    </v-snackbar>

    <v-dialog v-model="supportSessionEnded" persistent max-width="480">
      <v-card>
        <v-card-title>Support-Sitzung beendet</v-card-title>
        <v-card-text>Dieses Fenster kann jetzt geschlossen werden. Das Admin-Dashboard bleibt geöffnet.</v-card-text>
      </v-card>
    </v-dialog>
    <PwaInstallPrompt
      v-if="!isSupportSession"
      :authenticated="!!mySelf"
      app-name="Smart Energy Dashboard"
      storage-key="dashboard:pwa-install"
      @availability-change="pwaInstallAvailable = $event"
    />
  </v-app>
</template>

<script>
import { createDashboardPoller, stopDashboardTimer } from "./utils/dashboardPolling";
import { mapState, mapActions, mapGetters } from "vuex";
import _ from "lodash";
import packageJson from "../package.json";
import api from "./api";
import messaging from "./api/messaging";
import runtime from "./api/runtime";
import { OBS_APP_ROOT } from "./config";
import { preferredProjectId } from "./utils/projectSelection";
import { filterSupportUsersByProject } from "./utils/projectSupportUsers";
import { syncPushSubscription } from "./utils/pushNotifications";
import PwaInstallPrompt from "./components/PwaInstallPrompt.vue";

export default {
  name: "App",
  components: { PwaInstallPrompt },
  data() {
    return {
      layoutMode: 1, // Start: 1 View
      drawer: false,
      items: [],
      //mini: true,
      right: null,
      sw_name: "Smart Energy Management",
      sw_version: "V" + packageJson.version, //"V1.7.33",
      developer: "Schwarzl IT",
      web: "www.schwarzl-it.com",
      email: "office@schwarzl-it.com",
      agentApiStatus: "unknown",
      agentApiCheckedAt: null,
      agentExecutionRuntime: null,
      agentApiStatusInterval: null,
      adminContextInitialized: false,
      pendingMqttPermissionRequests: [],
      supportUsers: [],
      selectedSupportUserId: null,
      supportLaunchPending: false,
      supportLaunchError: "",
      supportLaunchErrorVisible: false,
      supportSessionEnded: false,
      notificationDeliveries: [],
      notificationInterval: null,
      pushSyncedUserId: null,
      pwaInstallAvailable: false
    };
  },
  mounted() {
    //this.items = []
    //console.log("App Mounted");
    if (this.$route.name !== "supportSession") this.getMySelf();
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", this.handleServiceWorkerMessage);
    }
    window.addEventListener("dashboard-conversations-changed", this.handleNotificationsChanged);
    // Lade Dark Mode Einstellung beim Start
    if (this.mySelf?.dashboard_settings?.darkMode !== undefined) {
      this.$vuetify.theme.dark = this.mySelf.dashboard_settings.darkMode;
    }
    if (!this.$store.authInterval) this.$store.authInterval = createDashboardPoller(() => this.getMySelf({ silent: true }), 30000);
    // this.initData();
  },
  beforeDestroy() { this.IntervalOff(); },
  computed: {
    ...mapState({
      status: ({ user }) => user.status,
      loading: (state) => state.loading,
      statusMySelf: ({ auth }) => auth.statusMySelf,
      mySelf: ({ auth }) => auth.mySelf,
      Drawer: (state) => state.drawer,
      Alerts: ({ alert }) => alert.Alerts,
      Locations: ({ location }) => location.Locations,
    }),
    ...mapGetters("global", [
      "activeProjects",
      "projectLocationIds",
      "projectSlug",
      "selectedProject",
      "selectedProjectSlug",
      "selectedProjectLocationIds"
    ]),
    homeNavigationItem() {
      return (this.items || []).find(item => String(item.title).toLowerCase() === "home") || null;
    },
    sortedNavigationItems() {
      return (this.items || [])
        .filter(item => String(item.title).toLowerCase() !== "home")
        .sort((left, right) =>
          String(this.$t(left.title)).localeCompare(String(this.$t(right.title)), "de", {
            sensitivity: "base",
          })
        );
    },
    selectedProjectId: {
      get() {
        return this.$store.state.global.selectedProjectId;
      },
      set(value) {
        this.setSelectedProject(value);
        if (value) localStorage.setItem("dashboardSelectedProjectId", String(value));
      }
    },
    projectAlertCount() {
      if (!this.selectedProject) return 0;
      return (this.Alerts || []).filter(alert => {
        const projectId = alert?.project?._id || alert?.project;
        if (projectId && this.selectedProjectLocationIds.has(String(projectId))) return true;
        if (alert?.project_slug && String(alert.project_slug) === this.selectedProjectSlug) return true;
        const locationId = alert?.device?.location?._id || alert?.device?.location;
        return this.selectedProjectLocationIds.has(String(locationId || ""));
      }).length;
    },
    projectSelectItems() {
      return this.activeProjects.map(project => {
        const priorityOneAlertCount = this.priorityOneAlertCountForProject(project);
        return {
          ...project,
          priorityOneAlertCount,
          projectSelectText: `${project.name || "Unbenannt"} · ${priorityOneAlertCount}`
        };
      });
    },
    showProjectSelector() {
      return this.activeProjects.length > 0 && (this.isAdmin || this.activeProjects.length > 1);
    },
    pendingMqttPermissionCount() {
      if (!this.selectedProjectSlug) return 0;
      return this.pendingMqttPermissionRequests.filter(
        request => String(request.source_project_slug || "") === this.selectedProjectSlug
      ).length;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
      // smAndDown => true, wenn Gerät <= small
    },
    isAdmin() {
      return !!(this.mySelf && Array.isArray(this.mySelf.roles) && this.mySelf.roles.includes("admin"));
    },
    isSupportSession() {
      return !!this.mySelf?.support_session?.active;
    },
    unreadMessageCount() {
      return this.notificationDeliveries.reduce((sum, entry) => sum + Number(entry.unreadCount || 0), 0);
    },
    supportUserItems() {
      return filterSupportUsersByProject(
        this.supportUsers,
        this.Locations,
        this.selectedProjectLocationIds
      )
        .map(user => ({
          ...user,
          label: `${user.displayname || "Unbenannt"} · ${user.email}`,
        }))
        .sort((left, right) => left.label.localeCompare(right.label, "de", { sensitivity: "base" }));
    },
    selectedSupportUserIsObs() {
      const user = this.supportUserItems.find(item => String(item._id) === String(this.selectedSupportUserId || ""));
      return !!user?.obs_user;
    },
    agentApiStatusColor() {
      return {
        connected: "success",
        degraded: "warning",
        down: "error",
        checking: "info"
      }[this.agentApiStatus] || "grey";
    },
    agentApiStatusIcon() {
      return {
        connected: "mdi-cloud-check",
        degraded: "mdi-cloud-alert",
        down: "mdi-cloud-off-outline",
        checking: "mdi-cloud-sync-outline"
      }[this.agentApiStatus] || "mdi-cloud-question-outline";
    },
    agentApiStatusLabel() {
      if (this.agentApiStatus === "degraded" && this.agentExecutionRuntime) {
        return "Agent-System eingeschränkt";
      }
      return {
        connected: "Agent-API verbunden",
        degraded: "Agent-API gestört",
        down: "Agent-API nicht erreichbar",
        checking: "Agent-API wird geprüft"
      }[this.agentApiStatus] || "Agent-API unbekannt";
    },
    agentApiStatusTooltip() {
      const checkedAt = this.agentApiCheckedAt
        ? ` Letzte Prüfung: ${new Date(this.agentApiCheckedAt).toLocaleTimeString("de-AT")}.`
        : "";
      const action = this.agentApiStatus === "down"
        ? " Agenten können derzeit nicht initialisiert oder bearbeitet werden."
        : "";
      const runtime = this.agentExecutionRuntime;
      const runtimeInfo = runtime
        ? ` Ausführung: ${runtime.backend || "unbekannt"} (${runtime.status || "unbekannt"})${runtime.message ? ` – ${runtime.message}` : ""}.`
        : "";
      return `${this.agentApiStatusLabel}.${action}${runtimeInfo}${checkedAt} Klicken zum Aktualisieren.`;
    },
  },
  watch: {
    selectedProjectId() {
      this.selectedSupportUserId = null;
    },
    activeProjects(projects) {
      this.ensureSelectedProject(projects);
    },
    mySelf(value, previousValue) {
      if (String(value?._id || "") !== String(previousValue?._id || "")) {
        this.$store.commit("global/SET_ACCESSIBLE_PROJECTS", []);
        this.setSelectedProject(null);
      }
      if (!value) {
        this.stopNotificationPolling();
        this.pushSyncedUserId = null;
      } else if (!this.isSupportSession) {
        this.startNotificationPolling();
        const userId = String(value._id || "");
        if (userId && this.pushSyncedUserId !== userId) {
          this.pushSyncedUserId = userId;
          syncPushSubscription().catch(() => {
            if (this.pushSyncedUserId === userId) this.pushSyncedUserId = null;
          });
        }
      }
      if (value && this.isSupportSession) this.loadNotificationCount();
      if (value && value._id) {
        this.startMetadataSync({ scopeKey: value._id });
      } else {
        this.stopMetadataSync({ reset: true });
      }
      // Lade Dark Mode Einstellung vom User
      if (value?.dashboard_settings?.darkMode !== undefined) {
        this.$vuetify.theme.dark = value.dashboard_settings.darkMode;
      }
      // console.log("Check permission ", value, this.$route);
      if (!value) {
        let to = this.$route;

        if (
          to.name == "login" ||
          to.name == "resetPassword" ||
          to.name == "resetPasswordConfirm" ||
          to.name == "signUp" ||
          to.name == "accountActivation" ||
          to.name == "Dsgvo"
        ) {
         //
        } else {
          this.IntervalOff(); 
          this.$router.push({ name: "login" });
        }

        //console.log("No mySelf!");
        
      }   
      this.items = [];
      try {
        // console.log(this.mySelf.roles)
        // console.log(this.mySelf.permissions)
        if (this.mySelf.roles.includes("superUser") || this.mySelf.roles.includes("user")) {
          if (!_.find(this.items, { title: "home" })) {
            const route = _.find(this.$router.options.routes, {
              name: "home",
            });

            this.items.push(this.toNavItem(route));
          }
          if (!_.find(this.items, { title: "user" })) {
            const route = _.find(this.$router.options.routes, {
              name: "User",
            });
            // console.log("Route: ", route, this.$router.options.routes)
            this.items.push(this.toNavItem(route));
          }
        }
        
        if (this.mySelf.roles.includes("admin")) {
          this.$router.options.routes.forEach((route) => {
            if (!_.isUndefined(route.icon)) {
              if (!(route.name === "admin") && !(route.name === "location")) {
                this.items.push(this.toNavItem(route));
              }
            }
          });
          if (!_.find(this.items, { title: "admin" })) {
            const route = _.find(this.$router.options.routes, {
              name: "admin",
            });
            this.items.push(this.toNavItem(route));
          }
          if (!_.find(this.items, { title: "location" })) {
            const route = _.find(this.$router.options.routes, {
              name: "location",
            });
            this.items.push(this.toNavItem(route));
          }
          
        } else if (this.mySelf.permissions.includes("project")) {
          // console.log("Includes Project Permission")
          this.$router.options.routes.forEach((route) => {
            if (!_.isUndefined(route.icon)) {
              if (
                !(route.meta && route.meta.adminOnly) &&
                !(route.name === "home") &&
                !(route.name === "admin") &&
                !(route.name === "location") &&
                !(route.name === "device") &&
                !(route.name === "contract") &&
                !(route.name === "user") &&
                !(route.name === "lifecycle") &&
                !(route.name === "mqttPermissions") &&
                !(route.name === "heatcontrolConfiguration")
              ) {
                this.items.push(this.toNavItem(route));
              }
            }
          });
        } else if (this.mySelf.permissions.includes("site")) {
          const route = _.find(this.$router.options.routes, { name: "projectSetup" });
          if (route) this.items.push(this.toNavItem(route));
        }
        const optimizerRoute = _.find(this.$router.options.routes, { name: "Energieoptimierung" });
        if (optimizerRoute && !this.items.some(item => item.path === optimizerRoute.path)) {
          this.items.push(this.toNavItem(optimizerRoute));
        }
      } catch (err) {
        console.log("Error: ", err)
      }

      if (this.isAdmin) {
        this.startAgentApiStatusPolling();
        this.initializeAdminContext();
        this.loadSupportUsers();
      } else {
        this.stopAgentApiStatusPolling();
        this.agentApiStatus = "unknown";
        this.agentApiCheckedAt = null;
        this.agentExecutionRuntime = null;
        this.stopAdminContextPolling();
      }
      this.ensureSelectedProject();
    },
  },
  destroyed() {
    this.IntervalOff();
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.removeEventListener("message", this.handleServiceWorkerMessage);
    }
    window.removeEventListener("dashboard-conversations-changed", this.handleNotificationsChanged);
  },
  methods: {
    ...mapActions("auth", ["getMySelf", "logout", "updateDashboardSettings"]),
    ...mapActions("global", ["setSelectedProject"]),
    ...mapActions("alert", ["getAlerts"]),
    ...mapActions("metadata_sync", {
      startMetadataSync: "start",
      stopMetadataSync: "stop",
      ensureMetadata: "ensureMetadata",
    }),
    ensureSelectedProject(projects = this.activeProjects) {
      const nextProjectId = this.mySelf
        ? preferredProjectId({
          projects,
          currentId: this.selectedProjectId,
          storedId: localStorage.getItem("dashboardSelectedProjectId"),
          preferTagger: this.isAdmin,
        })
        : null;

      if (String(nextProjectId || "") === String(this.selectedProjectId || "")) return;
      if (nextProjectId) this.selectedProjectId = nextProjectId;
      else this.setSelectedProject(null);
    },
    // ...mapActions("global", ["getGlobal"]),
    // async initData() {
    //   await this.getGlobal({});
    // },
    toNavItem(route) {
      return {
        title: route.name,
        icon: route.icon,
        color: route.color,
        path: route.path,
        descriptionKey: route.descriptionKey || "",
      };
    },
    toggleDarkMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      // Speichere die Einstellung
      this.updateDashboardSettings({ darkMode: this.$vuetify.theme.dark });
    },
    openMessages() {
      if (this.$route.name !== "Nachrichten") this.$router.push({ name: "Nachrichten" });
    },
    openPwaInstall() {
      this.$root.$emit("open-pwa-install");
    },
    async loadNotificationCount() {
      if (!this.mySelf) return;
      const userId = String(this.mySelf._id);
      try {
        const projects = (await messaging.projects()).body || [];
        if (String(this.mySelf?._id || "") !== userId) return;
        this.$store.commit("global/SET_ACCESSIBLE_PROJECTS", projects);
        if (this.isSupportSession) return;
        const deliveries = await Promise.all(projects.map(async project => ({ unreadCount: ((await messaging.unread(project._id)).body || {}).count || 0 })));
        if (String(this.mySelf?._id || "") === userId) this.notificationDeliveries = deliveries;
      } catch (error) {
        // Authentication errors remain handled by the global API flow.
      }
    },
    handleNotificationsChanged(event) {
      const deliveries = event?.detail?.deliveries;
      if (Array.isArray(deliveries)) {
        this.notificationDeliveries = deliveries;
        return;
      }
      this.loadNotificationCount();
    },
    startNotificationPolling() {
      if (this.notificationInterval) return;
      this.loadNotificationCount();
      this.notificationInterval = createDashboardPoller(() => this.loadNotificationCount(), 60000);
    },
    stopNotificationPolling() {
      stopDashboardTimer(this.notificationInterval);
      this.notificationInterval = null;
      this.notificationDeliveries = [];
    },
    handleServiceWorkerMessage(event) {
      if (event.data?.type !== "OPEN_DASHBOARD_MESSAGES") return;
      const query = { project: event.data.projectId, conversation: event.data.conversationId, message: event.data.messageId };
      this.$router.push({ name: "Nachrichten", query }).catch(() => {});
    },
    priorityOneAlertCountForProject(project) {
      const projectLocationIds = this.projectLocationIds(project);
      const projectSlug = this.projectSlug(project);

      return (this.Alerts || []).filter(alert => {
        if (Number(alert?.priority) !== 1) return false;

        const alertProjectId = alert?.project?._id || alert?.project;
        if (alertProjectId && projectLocationIds.has(String(alertProjectId))) return true;
        if (alert?.project_slug && String(alert.project_slug) === projectSlug) return true;

        const locationId = alert?.device?.location?._id || alert?.device?.location;
        return projectLocationIds.has(String(locationId || ""));
      }).length;
    },
    async initializeAdminContext() {
      if (this.adminContextInitialized) return;
      this.adminContextInitialized = true;
      await Promise.allSettled([this.ensureMetadata(), this.getAlerts({})]);
      await this.refreshPendingMqttPermissionCount();
      this.$store.adminContextInterval = createDashboardPoller(() => this.refreshAdminContextIndicators(), 30000);
    },
    async refreshAdminContextIndicators() {
      if (!this.isAdmin) return;
      await Promise.allSettled([this.getAlerts({}), this.refreshPendingMqttPermissionCount()]);
    },
    async refreshPendingMqttPermissionCount() {
      try {
        const response = await api.getMqttPermissionRequests({ status: "pending" });
        const requests = response?.body || response || [];
        this.pendingMqttPermissionRequests = Array.isArray(requests) ? requests : [];
      } catch (err) {
        this.pendingMqttPermissionRequests = [];
      }
    },
    stopAdminContextPolling() {
      if (this.$store.adminContextInterval) {
        stopDashboardTimer(this.$store.adminContextInterval);
        this.$store.adminContextInterval = null;
      }
      this.adminContextInitialized = false;
      this.pendingMqttPermissionRequests = [];
    },
    openProjectAlerts() {
      const target = { name: "home", query: { show: "alerts", at: String(Date.now()) } };
      if (this.$route.name === "home") this.$router.replace(target);
      else this.$router.push(target);
    },
    openMqttPermissions() {
      const target = { name: "lifecycle", query: { tab: "permissions" } };
      if (this.$route.name === "lifecycle") {
        if (this.$route.query.tab !== "permissions") this.$router.replace(target);
      } else this.$router.push(target);
    },
    startAgentApiStatusPolling() {
      if (!this.agentApiStatusInterval) {
        this.agentApiStatusInterval = createDashboardPoller(() => this.checkAgentApiStatus(), 30000);
      }
      this.checkAgentApiStatus();
    },
    stopAgentApiStatusPolling() {
      if (this.agentApiStatusInterval) {
        stopDashboardTimer(this.agentApiStatusInterval);
        this.agentApiStatusInterval = null;
      }
    },
    async checkAgentApiStatus() {
      if (!this.isAdmin || this.agentApiStatus === "checking") return;

      this.agentApiStatus = "checking";
      try {
        const projects = (await messaging.projects()).body || [];
        if (!projects.length) { this.agentApiStatus = "unknown"; return; }
        await runtime.request(projects[0]._id, "definitions");
        const response = { body: { connected: true, healthy: true } };
        if (!this.isAdmin) return;
        const health = response && response.body ? response.body : {};
        this.agentApiCheckedAt = health.checkedAt || new Date().toISOString();
        this.agentExecutionRuntime = health.executionRuntime || null;
        if (!health.connected) {
          this.agentApiStatus = "down";
        } else {
          this.agentApiStatus = health.healthy === false ? "degraded" : "connected";
        }
      } catch (err) {
        if (!this.isAdmin) return;
        this.agentApiCheckedAt = new Date().toISOString();
        this.agentExecutionRuntime = null;
        this.agentApiStatus = "down";
      }
    },
    async loadSupportUsers() {
      try {
        const response = await api.getUser();
        this.supportUsers = Array.isArray(response?.body) ? response.body : [];
      } catch (err) {
        this.supportUsers = [];
      }
    },
    async openSupportApplication(application) {
      if (!this.selectedSupportUserId || this.supportLaunchPending) return;

      const supportWindow = window.open("about:blank", "_blank");
      if (supportWindow) supportWindow.opener = null;
      this.supportLaunchPending = true;
      this.supportLaunchError = "";

      try {
        const response = await api.createSupportSession({
          userId: this.selectedSupportUserId,
          application,
        });
        const code = response.body.code;
        let url;

        if (application === "obs_web") {
          const base = OBS_APP_ROOT.replace(/\/$/, "");
          url = `${base}/#/support-session?code=${encodeURIComponent(code)}`;
        } else {
          const resolved = this.$router.resolve({ name: "supportSession", hash: `#${code}` });
          url = new URL(resolved.href, window.location.origin).href;
        }

        if (!supportWindow) throw new Error("Das neue Fenster wurde vom Browser blockiert.");
        supportWindow.location.replace(url);
      } catch (err) {
        if (supportWindow) supportWindow.close();
        this.supportLaunchError = err.message || "Die Support-Sitzung konnte nicht gestartet werden.";
        this.supportLaunchErrorVisible = true;
      } finally {
        this.supportLaunchPending = false;
      }
    },
    async endSupportSession() {
      try {
        await api.endSupportSession();
      } catch (err) {
        // The session may already have expired; always clear the local token.
      }
      sessionStorage.removeItem("SupportAuthorization");
      this.IntervalOff();
      window.close();
      window.setTimeout(() => {
        this.supportSessionEnded = true;
      }, 100);
    },
    pushRoute(item) {
      let item_path = item.path;
      item_path = item_path.slice(1, item.path.length);
      //this.mini = true
      //this.drawer = false
      this.$router.push(item_path);
    },
    actualRoute(path) {
      let getRoute = _.find(this.items, { path });
      if (_.isUndefined(getRoute)) {
        getRoute = {
          color: "",
          icon: "",
          name: "",
        };
      }
      return getRoute;
    },
    IntervalOff() {
      this.stopNotificationPolling();
      this.stopAgentApiStatusPolling();
      this.stopAdminContextPolling();
      this.stopMetadataSync();
      try {
        if (!_.isUndefined(this.$store.authInterval)) {
          stopDashboardTimer(this.$store.authInterval);
          this.$store.authInterval = undefined;
        }
      } catch (e) {
        //
      }
    },
  },
};
</script>

<!-- .body {
  
  overflow-y: auto !important; // override Vuetify's default style

}

.html {
  
  overflow-y: auto !important; // override Vuetify's default style

}
body {
  
  overflow-y: auto !important; // override Vuetify's default style

}
html {
  
  overflow-y: auto !important; // override Vuetify's default style
} -->

<style>
  /* ===== BASE STYLES ===== */
  html {
    overflow-y: hidden;
  }

  html,
  body,
  #app {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
  }

  .v-application {
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;
  }

  .card--flex-toolbar {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  /* ===== DARK THEME ===== */
  .app-dark {
    background: linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 50%, #16213e 100%) !important;
    min-height: 100vh;
  }

  .app-dark .main-content-wrapper {
    background: transparent !important;
  }

  .app-dark .main-content-area {
    background: transparent;
  }

  /* Dark App Bar */
  .app-bar-dark {
    background: linear-gradient(90deg, rgba(22, 33, 62, 0.95) 0%, rgba(26, 26, 46, 0.95) 100%) !important;
    border-bottom: 1px solid rgba(0, 188, 212, 0.3) !important;
    backdrop-filter: blur(10px);
  }

  .app-bar-dark .app-bar-title {
    color: #e0e0e0;
    font-weight: 500;
    font-size: 1.1rem;
    text-transform: capitalize;
    letter-spacing: 0.5px;
  }

  /* Dark Navigation Drawer */
  .nav-drawer-dark {
    background: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%) !important;
    border-right: 1px solid rgba(0, 188, 212, 0.2) !important;
  }

  .nav-drawer-dark .nav-brand {
    background: rgba(0, 188, 212, 0.1);
    border-bottom: 1px solid rgba(0, 188, 212, 0.2);
  }

  .nav-drawer-dark .nav-brand-text {
    color: #00BCD4;
    font-weight: 700;
    font-size: 1rem;
    letter-spacing: 2px;
  }

  .nav-drawer-dark .nav-item {
    border-radius: 8px;
    transition: all 0.3s ease;
  }

  .nav-drawer-dark .nav-item:hover {
    background: rgba(0, 188, 212, 0.15) !important;
  }

  .nav-drawer-dark .nav-item-active {
    background: rgba(0, 188, 212, 0.2) !important;
    border-left: 3px solid #00BCD4;
  }

  .nav-drawer-dark .nav-item-text {
    color: #e0e0e0 !important;
  }

  .nav-drawer-dark .nav-item-subtitle {
    color: rgba(224, 224, 224, 0.7) !important;
    white-space: normal;
    line-height: 1.15rem;
  }

  .nav-drawer-dark .nav-footer {
    background: rgba(0, 0, 0, 0.3);
    border-top: 1px solid rgba(0, 188, 212, 0.2);
  }

  .nav-drawer-dark .nav-footer-text {
    color: rgba(255, 255, 255, 0.5);
  }

  .nav-drawer-dark .divider-dark {
    border-color: rgba(0, 188, 212, 0.2) !important;
  }

  /* Dark Mode Toggle */
  .mode-toggle-dark {
    background: rgba(0, 188, 212, 0.1) !important;
    border: 1px solid rgba(0, 188, 212, 0.3) !important;
    border-radius: 6px !important;
  }

  .mode-toggle-dark .v-btn {
    color: #e0e0e0 !important;
    background: transparent !important;
  }
  /* Ensure the v-btn inner content also inherits the color (numbers/text) */
  .mode-toggle-dark .v-btn .v-btn__content {
    color: #e0e0e0 !important;
  }

  .mode-toggle-dark .v-btn--active {
    background: rgba(0, 188, 212, 0.3) !important;
    color: #00BCD4 !important;
  }
  .mode-toggle-dark .v-btn--active .v-btn__content {
    color: #00BCD4 !important;
  }

  /* ===== LIGHT THEME ===== */
  .app-light {
    background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 50%, #dde4ed 100%) !important;
    min-height: 100vh;
  }

  .app-light .main-content-wrapper {
    background: transparent !important;
  }

  .app-light .main-content-area {
    background: transparent;
  }

  /* Light App Bar */
  .app-bar-light {
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 249, 250, 0.95) 100%) !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
    backdrop-filter: blur(10px);
  }

  .app-bar-light .app-bar-title {
    color: #333;
    font-weight: 500;
    font-size: 1.1rem;
    text-transform: capitalize;
    letter-spacing: 0.5px;
  }

  /* Light Navigation Drawer */
  .nav-drawer-light {
    background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%) !important;
    border-right: 1px solid rgba(0, 0, 0, 0.08) !important;
  }

  .nav-drawer-light .nav-brand {
    background: rgba(255, 193, 7, 0.1);
    border-bottom: 1px solid rgba(255, 193, 7, 0.2);
  }

  .nav-drawer-light .nav-brand-text {
    color: #FFC107;
    font-weight: 700;
    font-size: 1rem;
    letter-spacing: 2px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  }

  .nav-drawer-light .nav-item {
    border-radius: 8px;
    transition: all 0.3s ease;
  }

  .nav-drawer-light .nav-item:hover {
    background: rgba(255, 193, 7, 0.15) !important;
  }

  .nav-drawer-light .nav-item-active {
    background: rgba(255, 193, 7, 0.2) !important;
    border-left: 3px solid #FFC107;
  }

  .nav-drawer-light .nav-item-text {
    color: #333 !important;
  }

  .nav-drawer-light .nav-item-subtitle {
    color: rgba(51, 51, 51, 0.68) !important;
    white-space: normal;
    line-height: 1.15rem;
  }

  .nav-drawer-light .nav-footer {
    background: rgba(0, 0, 0, 0.03);
    border-top: 1px solid rgba(0, 0, 0, 0.08);
  }

  .nav-drawer-light .nav-footer-text {
    color: rgba(0, 0, 0, 0.5);
  }

  .nav-drawer-light .divider-light {
    border-color: rgba(0, 0, 0, 0.08) !important;
  }

  /* Light Mode Toggle */
  .mode-toggle {
    background: rgba(255, 193, 7, 0.1) !important;
    border: 1px solid rgba(255, 193, 7, 0.3) !important;
    border-radius: 6px !important;
    overflow: hidden;
  }

  .mode-toggle .v-btn {
    color: #333 !important;
    background: transparent !important;
    min-width: 36px !important;
    height: 28px !important;
  }
  .mode-toggle .v-btn .v-btn__content {
    color: #333 !important;
  }

  .mode-toggle .v-btn--active {
    background: rgba(255, 193, 7, 0.4) !important;
    color: #333 !important;
  }
  .mode-toggle .v-btn--active .v-btn__content {
    color: #333 !important;
  }

  /* ===== GLOBAL CARD STYLES are centralized in src/assets/global-theme.css ===== */
  .app-dark .v-card--flat {
    background: transparent !important;
    border: none !important;
  }

  .app-light .v-card--flat {
    background: transparent !important;
    border: none !important;
  }

  /* ===== LOADING OVERLAY ===== */
  .loading-overlay {
    position: fixed;
    z-index: 9997;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    background: black;
    opacity: 0.05;
  }

  .global-project-select {
    max-width: 300px;
  }

  .support-user-select {
    min-width: 220px;
    max-width: 300px;
  }

  .app-bar-reload-slot {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 40px;
    width: 40px;
    height: 40px;
    box-sizing: border-box;
  }

  .global-project-select-mobile {
    margin: 4px 8px 6px !important;
    max-width: none;
    width: calc(100% - 16px);
  }

  .global-project-select-mobile .v-input__slot {
    min-height: 40px !important;
  }

  .v-app-bar .v-toolbar__extension {
    padding: 0 !important;
  }

  .project-priority-chip {
    flex: 0 0 auto;
    justify-content: center;
    min-width: 30px;
    font-weight: 700;
  }

  /* ===== ALERT STYLES ===== */
  .alertStyle {
    position: absolute;
    bottom: 5%;
  }

  /* ===== SCROLLBAR STYLING ===== */
  .app-dark ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  .app-dark ::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.2);
  }

  .app-dark ::-webkit-scrollbar-thumb {
    background: rgba(0, 188, 212, 0.4);
    border-radius: 4px;
  }

  .app-dark ::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 188, 212, 0.6);
  }

  .app-light ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  .app-light ::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.05);
  }

  .app-light ::-webkit-scrollbar-thumb {
    background: rgba(255, 193, 7, 0.4);
    border-radius: 4px;
  }

  .app-light ::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 193, 7, 0.6);
  }

  /* ===== UTILITY CLASSES ===== */
  .box {
    border: solid 1px red;
  }
</style>
